export default __webpack_public_path__ + "static/media/help.31d6cfe0.md";